<template>
  <div>
    <div style="width:1280px">
      <img :src="adminIntro1" usemap="#map" name="adminIntro1" />
      <map name="map">
        <area
          shape="rect"
          coords="339,487,678,549"
          v-bind:href="`/mileage/${$store.state.mallId}/home`"
          target="_blank"
        />
      </map>
    </div>
    <MallManagerInfo ref="MallManagerInfo"></MallManagerInfo>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import MallManagerInfo from "@/components/mileage/service/modal/MallManagerInfo.vue";

export default {
  data: () => ({
    adminIntro1: require("../../../assets/mileage/images/app_main.png"),
    ordersPayload: {
      mall_name: null,
      mall_manager: null,
      mall_phone: null,
      mall_email: null,
    },
  }),
  methods: {
    getMallInfo: async function() {
      try {
        let res = await M.api(M.entry("/get/mileage/usage"));
        localStorage.setItem("mall_name", res.mall_name);
        this.ordersPayload.mall_name = res.mall_name;
        localStorage.setItem("expires_at", res.expires_at);
      } catch (e) {
        localStorage.setItem("mall_name", "");
        localStorage.setItem("expires_at", "");
      }
    },
    getPaymentInfo: async function() {
      try {
        let data = await M.api(M.entry("/get/orders/latest"), {});
        if (data) {
          this.ordersPayload.mall_name = data.mall_name;
          this.ordersPayload.mall_manager = data.mall_manager;
          this.ordersPayload.mall_phone = data.mall_phone;
          this.ordersPayload.mall_email = data.mall_email;
        }
      } catch {
        this.ordersPayload.mall_name = "";
        this.ordersPayload.mall_manager = "";
        this.ordersPayload.mall_phone = "";
        this.ordersPayload.mall_email = "";
      }
    },
  },
  created: async function() {
    await this.getMallInfo();
    await this.getPaymentInfo();
    if (!this.ordersPayload.mall_phone) {
      this.$refs.MallManagerInfo.show(this.ordersPayload);
    }
  },
  components: {
    MallManagerInfo,
  },
};
</script>
